module.exports = __webpack_public_path__ + "static/spaceman-61a557303fa86eefd06a435583aa9388.jpg";